export function createOptionalScripts({ win, doc, analyticsId, supportProperty, supportWidget }) {
  let analyticsLoaded = false;
  let supportLoaded = false;
  let reloadRequested = false;
  const pageMetadata = () => {
    const sections = ['login', 'register', 'jobs', 'companies', 'professionals', 'about', 'faq', 'privacy-policy', 'cookies-policy', 'terms', 'dashboard', 'status', 'compatibility'];
    const section = win.location.pathname.split('/')[1];
    const path = sections.includes(section) ? `/${section}` : section ? '/other' : '/';
    return { page_path: path, page_location: `${win.location.origin || 'https://jobifull.eu'}${path}`, page_title: 'Jobifull', page_referrer: '' };
  };
  const addScript = (id, src) => {
    if (doc.getElementById(id)) return;
    const script = doc.createElement('script');
    script.id = id; script.async = true; script.src = src;
    script.referrerPolicy = 'strict-origin-when-cross-origin';
    doc.head.appendChild(script);
  };
  const isConfiguredTawkIdentifier = value => {
    if (typeof value !== 'string') return false;
    const identifier = value.trim();
    return /^[a-z0-9]+$/i.test(identifier) && !['null', 'undefined', 'none'].includes(identifier.toLowerCase());
  };
  const clearProviderCookies = () => {
    const domains = ['', win.location.hostname, `.${win.location.hostname}`, `.${win.location.hostname.split('.').slice(-2).join('.')}`];
    for (const entry of doc.cookie.split(';')) {
      const name = entry.split('=')[0].trim();
      if (!/^(_ga($|_)|_gid$|_gat($|_)|TawkConnectionTime$|twk_|tawk_)/i.test(name)) continue;
      for (const domain of domains) doc.cookie = `${name}=; Max-Age=0; Path=/;${domain ? ` Domain=${domain};` : ''}`;
    }
  };
  function apply({ analytics, support }) {
    if ((analyticsLoaded && !analytics) || (supportLoaded && !support)) {
      if (analyticsId) win[`ga-disable-${analyticsId}`] = true;
      win.gtag?.('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      try { clearProviderCookies(); } catch { /* Storage may be disabled; the reload still stops executed providers. */ }
      // Executed third-party code cannot be unloaded reliably: restart into the saved denied state.
      if (!reloadRequested) { reloadRequested = true; win.location.reload(); }
      return;
    }
    if (analytics && !analyticsLoaded && /^(G-[A-Z0-9]+|UA-\d+-\d+)$/i.test(analyticsId || '')) {
      win.dataLayer = win.dataLayer || [];
      win.gtag = function () { win.dataLayer.push(arguments); };
      win[`ga-disable-${analyticsId}`] = false;
      win.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      win.gtag('js', new Date());
      win.gtag('set', pageMetadata());
      win.gtag('config', analyticsId, { ...pageMetadata(), send_page_view: false, anonymize_ip: true, allow_google_signals: false, allow_ad_personalization_signals: false });
      addScript('jobifull-analytics-script', `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(analyticsId)}`);
      analyticsLoaded = true;
      pageView();
    }
    if (support && !supportLoaded && isConfiguredTawkIdentifier(supportProperty) && isConfiguredTawkIdentifier(supportWidget)) {
      addScript('jobifull-tawk-script', `https://embed.tawk.to/${supportProperty.trim()}/${supportWidget.trim()}`);
      supportLoaded = true;
    }
  }
  function pageView() {
    // Route groups only: URLs/titles can contain names, e-mails or searches.
    if (analyticsLoaded && !reloadRequested) {
      win.gtag('set', pageMetadata());
      win.gtag('event', 'page_view', pageMetadata());
    }
  }
  return { apply, pageView };
}
